// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__1npPU","messages":"Chat_messages__3mh-7","dateDivider":"Chat_dateDivider__2LdyH"};